import { createStore } from 'vuex';
import global from '@/global-view/vuex';
import portal from '@/global-view/portal/vuex';
import announcements from 'ç/announcement/vuex';

const store = createStore({
  strict: true,
  modules: {
    global,
    portal,
    announcements,
  },
});

export default store;
